// @flow

import { connect } from 'react-redux';
import Search from './search';
import { User } from '../../models/user';
import { updateSearchParam, changeSearchType, resetSearchPrams } from '../../services/search';

export type Props = {
  fetching: boolean,
  authenticating: boolean,
  search: any,
  location: RouteComponentProps,
  user: User,
  searchParams: any,
  searchBy: string,
  changeSearchType: (type: string) => void,
  resetSearchPrams: (type: string) => void,
  updateSearchParam: (name: string, value: string) => void,
};

const mapState = ({ authentication, search }) => ({
  authenticating: authentication.authenticating,
  user: authentication.user,
  fetching: search.fetching,
  search: search.search,
  searchParams: search.searchParams,
  searchBy: search.searchBy,
});

const mapDispatch = { updateSearchParam, changeSearchType, resetSearchPrams };

export default connect(
  mapState,
  mapDispatch,
)(Search);
